import { defineStore } from 'pinia'
import { reactive, ref } from 'vue'
import type { Filters, FilterItem } from '@/types/main'

export const useFilterStore = defineStore('filter', () => {
  const isOpen = ref(false)
  const filters = reactive<Filters>({
    search: '',
    selected: null,
  })

  const clearFilter = () => {
    filters.selected = null
    filters.search = ''
  }

  const deleteFilterItem = (key: string) => {
    if (filters.selected) {
      delete filters.selected[key]
    }
  }

  const setFilterItem = (key: string, value: FilterItem) => {
    if (filters.selected) {
      filters.selected[key] = value
    } else {
      filters.selected = {}
      filters.selected[key] = value
    }
  }

  const $reset = () => {
    clearFilter()
  }

  return {
    isOpen,
    filters,
    clearFilter,
    setFilterItem,
    deleteFilterItem,
    $reset,
  }
})
